import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  makeStyles,
  Divider,
  Box,
  Typography,
} from "@material-ui/core";
import { ColetaStepper } from "./ColetaStepper";
import { MetodoCard } from "./MetodoCard";
import CodigoIcon from "./CodigoIcon";
import BarcodeIcon from "./BarcodeIcon";
import { DialogActions } from "../components/DialogActions";
import DialogEtiquetaContent from "../DialogEtiqueta/DialogEtiquetaContent";
import DialogTokenContent from "../DialogToken/DialogTokenContent";

const useStyles = makeStyles((theme) => ({
  dialog: {
    maxWidth: 690,
    width: "100%",
  },
  divider: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(1),
    marginLeft: theme.spacing(3),
    marginRight: theme.spacing(3),
    height: 2,
    background: "#EEE",
  },
  dividerBottom: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(4),
    height: 2,
    background: "#EEE",
  },
  content: {
    display: "flex",
    flexDirection: "column",
    padding: 24,
  },
  bottomContent: {
    marginLeft: theme.spacing(3),
    marginRight: theme.spacing(3),
    marginBottom: theme.spacing(3),
  },
  titleBlock: {
    display: "flex",
    flexDirection: "column",
    gap: 8,
    marginBottom: theme.spacing(4),
  },
  contentTitle: {
    fontSize: 20,
    color: "#000",
    fontWeight: 400,
    lineHeight: "normal",
  },
  contentSubtitle: {
    fontSize: 14,
    color: "rgba(26, 26, 26, 0.6)",
    fontWeight: 400,
    lineHeight: "normal",
  },
  cardsContainer: {
    display: "flex",
    gap: 16,
  },
  footer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: theme.spacing(3),
  },
}));

export default function DialogColeta({ open, orderId, handleClose, handleSubmit, abbiamoStatus }) {
  const classes = useStyles();
  const [step, setStep] = useState(1);
  const [selectedMethod, setSelectedMethod] = useState(null);

  const handleBack = () => {
    setStep(1);
    setSelectedMethod(null);
  };

  const handleSelectMethod = (method) => {
    setSelectedMethod(method);
    setStep(2);
  };

  const handleExited = () => {
    setStep(1);
    setSelectedMethod(null);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      TransitionProps={{ onExited: handleExited }}
      classes={{ paper: classes.dialog }}
      maxWidth={false}
    >
      <ColetaStepper step={step} onBack={handleBack} />

      <Divider className={classes.divider} />

      {step === 1 ? (
        <DialogContent className={classes.content}>
          <Box className={classes.titleBlock}>
            <Typography className={classes.contentTitle}>
              Pergunte ao entregador o método de coleta e selecione abaixo.
            </Typography>
            <Typography className={classes.contentSubtitle}>
              O entregador deverá informar se a coleta será por código de
              retirada ou leitura da etiqueta.
            </Typography>
          </Box>

          <Box className={classes.cardsContainer}>
            <MetodoCard
              icon={<CodigoIcon />}
              title="Código"
              description="Um código será gerado e deverá ser informado ao entregador."
              onClick={() => handleSelectMethod("codigo")}
            />
            <MetodoCard
              icon={<BarcodeIcon />}
              title="Etiqueta"
              description="O entregador deverá ler o código de barras impresso na etiqueta."
              onClick={() => handleSelectMethod("etiqueta")}
            />
          </Box>
        </DialogContent>
      ) : (
        <DialogContent className={classes.content}>
          {selectedMethod === "codigo"
            ? (<DialogTokenContent orderId={orderId} isAbbiamoStatusNotDone={abbiamoStatus !== 'DONE'} />)
            : (<DialogEtiquetaContent handleClose={handleClose} isAbbiamoStatusNotDone={abbiamoStatus !== 'DONE'} />)
          }
        </DialogContent>
      )}

      <Box className={classes.bottomContent}>
        <Divider className={classes.dividerBottom} />
        <DialogActions disabled={!selectedMethod || abbiamoStatus !== 'DONE'} handleClose={handleClose} handleSubmit={handleSubmit} buttonText='CONFIRMAR RETIRADA' />
      </Box>

    </Dialog>
  );
}
